import React from "react";

import { useNavigation, useNotification } from "@refinedev/core";

import { MergeButton } from "@/components/common/merge-button";
import { RemoteSelect } from "@/components/fields/remote-select";
import { useGenreRepository } from "@/pages/genres/hooks/use-genre-repository";

export const GenreMergeButton = ({ id }: { id: string }) => {
  const { search, merge } = useGenreRepository();
  const { open } = useNotification();
  const { edit } = useNavigation();
  const [value, setValue] = React.useState<{ id: string; name: string }>();
  const [loading, setLoading] = React.useState(false);

  return (
    <MergeButton
      loading={loading}
      resource="genres"
      onConfirm={async (close) => {
        open?.({
          type: "success",
          message: `Merging genre ${id} into ${value?.name}...`,
        });
        if (value) {
          setLoading(true);
          await merge(id, value.id).finally(() => setLoading(false));
          setLoading(false);
          edit("genres", value.id);
          close();
        } else
          open?.({
            type: "error",
            message: "Please select a genre to merge into",
          });
      }}
    >
      <RemoteSelect<{ id: string; name: string }>
        value={value}
        onSearch={async (query) => {
          const response = await search(query);

          return response;
        }}
        onValueChanged={(value) => {
          if (value) setValue(value);
        }}
        accessorFn={(option) => ({
          id: option.id,
          name: option.name,
        })}
      />
    </MergeButton>
  );
};
